class States {

  static __permanent = {
    registerStep: "userType",
    registerFormData: {
      userType: "Agent"
    },
    profileStep: 0,
    profileFormData: {}
  }

  static __non_permanent = {
    showCreateAccount: true,
    indexScroll: 0,
    menuClick: ""
  }

}

export default States;